import { Config } from "../../../configurations/config";
export const spOffsiteWorkHours_API = {
	//------------------------ Listing Offsite Work Hours  -----------------------//
	GetDefaultEmployeeOffsiteRequests: `${Config.server_url}${Config.api_prefix}/OffsiteHours/EmployeeOffsiteHourRequests?pageNumber=1`,
	GetEmployeeOffsiteRequestsPagination: `${Config.server_url}${Config.api_prefix}/OffsiteHours/EmployeeOffsiteHourRequests`,
	GetSupervisorsEmployeeNameList: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees`,
	GetWorkType: `${Config.server_url}${Config.api_prefix}/OffsiteHours/GetWorkTypes`,
	GetDefaultEmployeeOffsiteRequestByID: `${Config.server_url}${Config.api_prefix}/OffsiteHours/EmployeeOffsiteHourRequests`,
	ApproveRejectBulkApplications: `${Config.server_url}${Config.api_prefix}/OffsiteHours/EmployeeOffsiteHourBulkRequests`,

	ExportToExcel: `${Config.server_url}${Config.api_prefix}/OffsiteHours/ExportToExcel`,
	//------------------------ manage Offsite Work Hours -----------------------//
	PatchEmployeeOffsiteHourRequests: `${Config.server_url}${Config.api_prefix}/OffsiteHours/EmployeeOffsiteHourRequests`,

	//------------------------ Compensation -----------------------//
	GetCompensationById: `${Config.server_url}${Config.api_prefix}/OffsiteHours/CompensationLog`,
	PostCompensation: `${Config.server_url}${Config.api_prefix}/OffsiteHours/EmployeeOffsiteHourRequests`,
};
